import type { SxProps, Theme } from "@mui/material";

const fernieButtonSx = {
	focusRing: {
		"&.Mui-focusVisible": { outline: (theme: Theme) => `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 }
	},
	visuallyHidden: {
		border: 0,
		clip: "rect(0 0 0 0)",
		height: "1px",
		margin: "-1px",
		overflow: "hidden",
		padding: 0,
		position: "absolute",
		whiteSpace: "nowrap",
		width: "1px"
	}
} satisfies Record<"focusRing" | "visuallyHidden", SxProps<Theme>>;

export default fernieButtonSx;
